var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagGray600Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8661_46085)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6 10.59L14.96 7.32999L17.6 4.06999C18.06 3.49999 18.15 2.72999 17.84 2.06999C17.53 1.40999 16.87 0.98999 16.13 0.98999H3.77C2.73 0.98999 1.88 1.83999 1.88 2.87999V17.99C1.88 18.54 2.33 18.99 2.88001 18.99C3.43001 18.99 3.88 18.54 3.88 17.99V13.66H16.13C16.87 13.66 17.52 13.25 17.84 12.58C18.16 11.92 18.07 11.15 17.6 10.58V10.59ZM3.88 11.67V2.99999H15.89L12.89 6.69999C12.59 7.06999 12.59 7.58999 12.89 7.95999L15.89 11.66H3.88V11.67Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8661_46085"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagGray600Icon);
export default __webpack_public_path__ + "static/media/flag_gray600_icon.d1714d940b8fe5ede1fdf28cbf8c0a57.svg";
export { ForwardRef as ReactComponent };